<app-loader *ngIf="renameBrigadeLoading"></app-loader>
<div class="modal__header">
  <span class="title">Изменение названия бригады</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXRenameBrigade"></div>
</div>
<div class="modal__body">
  <div class="mt-16">
    <app-field>
      <label>Название бригады</label>
      <input type="text" class="input-text" [(ngModel)]="brigadeName" id="brigadeName" />
    </app-field>
  </div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" [disabled]="!brigadeName" (click)="onRenameBrigade()" id="appRenameBrigade">Готово</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseRenameBrigade"> Отмена </a>
  </div>
</div>
